import type { SocialLink, TeamCardProps } from '@kkf/design'

const MEMBER_SOCIALS: SocialLink[] = [
  { icon: 'facebook', href: '#', label: 'Facebook' },
  { icon: 'twitter', href: '#', label: 'Twitter' },
  { icon: 'linkedin-big-logo', href: '#', label: 'LinkedIn' },
  { icon: 'instagram', href: '#', label: 'Instagram' },
]

const DETAILS_ROUTE = '/team/jenny-wilson'

/**
 * Team listing — 8 members, all with placeholder name and role. The About page shows
 * the first 4 of the same set.
 */
export const TEAM_MEMBERS: TeamCardProps[] = Array.from({ length: 8 }, (_, i) => ({
  image: `/assets/img/member-${i + 1}.jpg`,
  name: 'John Doe',
  designation: 'Attorney',
  to: DETAILS_ROUTE,
  socials: MEMBER_SOCIALS,
}))

/** The About page renders a 4-member subset. */
export const TEAM_MEMBERS_HOME = TEAM_MEMBERS.slice(0, 4)
